import React, { type ReactNode } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { token } from '@atlaskit/tokens';

const InlineErrorMessage = ({
	message,
	id,
	role,
}: {
	message: string | ReactNode;
	id?: string;
	role?: string;
}) => (
	<InlineErrorMessageWrapper id={id} role={role}>
		<AlignedIcon>
			{/* The icon has no label because there is the error message right next to it */}
			<ErrorIcon color={token('color.text.accent.orange.bolder')} LEGACY_size="small" label="" />
		</AlignedIcon>
		<span>{message}</span>
	</InlineErrorMessageWrapper>
);

export default InlineErrorMessage;

// eslint-disable-next-line  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineErrorMessageWrapper = styled.div<{
	children?: ReactNode;
	id?: string;
	role?: string;
}>`
	font: ${token('font.body.UNSAFE_small')};
	margin-top: ${token('space.200')};
	color: ${token('color.text.danger')};
	display: flex;
	word-wrap: break-word;

	> * + * {
		margin-left: ${token('space.050')};
		/* Text wrapping of flex items is very inconsistent between browsers. min-width is for Chrome/Firefox/Safari/Edge, flex-basis is for IE */
		min-width: 0;
		flex-basis: 100%;
	}
`;

// The error icon has 2px padding inside it's viewbox. We need to subtract that padding so the icon aligns correctly.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AlignedIcon = styled2.div<{
	children?: ReactNode;
}>({
	display: 'flex',
	flexShrink: 0,
	marginLeft: token('space.negative.025'),
});
